import { render, staticRenderFns } from "./br.vue?vue&type=template&id=55ce1faa&"
import script from "./br.vue?vue&type=script&lang=js&"
export * from "./br.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports